import { z } from "zod";
import { vehicleTypeSchema, registrationDataSchema } from "../_shared";

export const bulkCreateVehicleRequest = z.object({
  vehicles: z.array(
    z.object({
      registrationNumber: z.string().nullable(),
      vehicleType: vehicleTypeSchema,
      company: z.uuid(),
      reference: z.string().nullable(),
      additionalCostPerKm: z.number().nullable(),
      contractStartDate: z.string().nullable(),
      contractEndDate: z.string().nullable(),
      contractMileage: z.number().nullable(),
      analyticCode: z.string().nullable(),
      departmentName: z.string().nullable(),
    }),
  ),
  registrationData: registrationDataSchema.optional(),
});

export type BulkCreateVehicleRequest = z.infer<
  typeof bulkCreateVehicleRequest
>;
